// extracted by mini-css-extract-plugin
export default {"chart":"LineChart_chart__x1Y2F","title":"LineChart_title__ig5nF"};